import { useCallback, useState } from 'react'
import type { AvailabilityFilters, AvailabilityMode, Granularity } from '@/types/ui/resource-availability'

const DEFAULTS: AvailabilityFilters = {
  mode: 'allocated',
  granularity: 'monthly',
}

export function useAvailabilityFilters(initial?: Partial<AvailabilityFilters>) {
  const [filters, setFilters] = useState<AvailabilityFilters>({ ...DEFAULTS, ...initial })

  const setMode = useCallback((mode: AvailabilityMode) => {
    setFilters(prev => ({ ...prev, mode }))
  }, [])

  const setGranularity = useCallback((granularity: Granularity) => {
    setFilters(prev => ({ ...prev, granularity }))
  }, [])

  return {
    filters,
    setMode,
    setGranularity,
  }
}

export function defaultMonthWindow(): { startMonth: string; endMonth: string } {
  const today = new Date()
  const start = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1))
  const end = new Date(Date.UTC(today.getFullYear(), today.getMonth() + 11, 1))
  const fmt = (d: Date) => `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-01`
  return { startMonth: fmt(start), endMonth: fmt(end) }
}
